module.exports = __webpack_public_path__ + "static/media/robot.88a548ca.png";